import React from 'react';
import { motion } from 'framer-motion';
import { Star, Users, Award } from 'lucide-react';
const TESTIMONIALS = [{
  text: 'Mi hijo de 7 años pasó de trabarse en cada palabra a leer párrafos completos en solo 3 semanas. Lloro de emoción cada vez que lo escucho leer solito.',
  name: 'María L.',
  city: 'Córdoba',
  role: 'Mamá'
}, {
  text: 'Lo uso con mis 32 alumnos de segundo grado. Es el recurso más completo y organizado que encontré en 8 años de docencia.',
  name: 'Luciana G.',
  city: 'Rosario',
  role: 'Docente'
}, {
  text: 'Mi hija odiaba leer. Ahora me pide que le imprima las actividades. El cambio fue increíble, y solo practicamos 10 minutos por día.',
  name: 'Carolina M.',
  city: 'Buenos Aires',
  role: 'Mamá'
}, {
  text: 'Como fonoaudióloga, lo recomiendo a todas las familias. El enfoque progresivo es exactamente lo que necesitan los chicos.',
  name: 'Andrea P.',
  city: 'Mendoza',
  role: 'Terapeuta'
}, {
  text: 'Probé de todo: videos, apps, cuadernillos sueltos. Nada funcionó hasta que encontré este kit. Mi hijo de 6 años ahora lee con confianza.',
  name: 'Gabriela R.',
  city: 'Tucumán',
  role: 'Mamá'
}];
export function SocialProof() {
  return <section className="py-20 px-4 bg-[#F0F8FF]" data-id="element-251">
      {' '}
      {/* Soft blue pastel */}
      <div className="max-w-6xl mx-auto" data-id="element-252">
        <div className="text-center mb-16" data-id="element-253">
          <h2 className="text-4xl font-black text-gray-900 mb-10" data-id="element-254">
            ⭐ Resultados reales que nos respaldan en toda la Argentina
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-16" data-id="element-255">
            <div className="bg-white p-6 rounded-2xl shadow-md border border-blue-100 flex flex-col items-center" data-id="element-256">
              <div className="flex text-yellow-400 mb-2" data-id="element-257">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-8 h-8 fill-current" data-id="element-258" />)}
              </div>
              <p className="text-xl font-bold text-gray-900" data-id="element-259">
                4.8 de calificación
              </p>
              <p className="text-gray-500" data-id="element-260">(457 madres)</p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-md border border-blue-100 flex flex-col items-center" data-id="element-261">
              <Users className="w-10 h-10 text-blue-500 mb-2" data-id="element-262" />
              <p className="text-xl font-bold text-gray-900" data-id="element-263">+2.000 docentes</p>
              <p className="text-gray-500" data-id="element-264">ya lo usan</p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-md border border-blue-100 flex flex-col items-center" data-id="element-265">
              <Award className="w-10 h-10 text-purple-500 mb-2" data-id="element-266" />
              <p className="text-xl font-bold text-gray-900 text-center" data-id="element-267">
                Método guiado por Profe Roxana
              </p>
              <p className="text-gray-500 text-center" data-id="element-268">
                (10+ años, +500 alumnos)
              </p>
            </div>
          </div>
        </div>

        <h3 className="text-3xl font-black text-center text-gray-900 mb-10" data-id="element-269">
          Lo que dicen otras familias / docentes
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-270">
          {TESTIMONIALS.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 flex flex-col" data-id="element-271">
              <div className="flex text-yellow-400 mb-4" data-id="element-272">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-273" />)}
              </div>
              <p className="text-gray-700 italic font-medium mb-6 flex-grow" data-id="element-274">
                "{t.text}"
              </p>
              <div className="border-t border-gray-100 pt-4" data-id="element-275">
                <p className="font-bold text-gray-900" data-id="element-276">{t.name}</p>
                <p className="text-sm text-gray-500" data-id="element-277">
                  {t.city} •{' '}
                  <span className="text-blue-600 font-semibold" data-id="element-278">{t.role}</span>
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}